
import { defineComponent } from "vue";

export default defineComponent({
  name: "Heading2",
  props: {
    variant: {
      type: String,
      validator(value: string) {
        return ["capitalized"].includes(value);
      },
    },
  },
});
